import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { personalInfo } from "../../data";

function Contact() {
  const ref = useScrollReveal();
  const [state, handleSubmit] = useForm("mgopgboq");

  return (
    <section id="contact" className="section contact-section">
      <div className="section-inner">
        <div ref={ref} className="reveal">
          <div className="contact-card">
            <p className="section-label" style={{ justifyContent: "center", display: "flex" }}>
              Get In Touch
            </p>
            <h2>Let's Work Together</h2>
            <p className="contact-desc">
              I'm always open to discussing new opportunities, interesting projects,
              or technical challenges. Drop me a message and I'll get back to you.
            </p>

            {state.succeeded ? (
              <div className="contact-success">
                Message sent — I'll get back to you soon!
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="cf-name">Name</label>
                    <input
                      id="cf-name"
                      type="text"
                      name="name"
                      placeholder="Your name"
                      required
                      autoComplete="name"
                    />
                    <ValidationError field="name" prefix="Name" errors={state.errors} className="contact-error" />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="cf-email">Email</label>
                    <input
                      id="cf-email"
                      type="email"
                      name="email"
                      placeholder="you@example.com"
                      required
                      autoComplete="email"
                    />
                    <ValidationError field="email" prefix="Email" errors={state.errors} className="contact-error" />
                  </div>
                </div>
                <div className="contact-form-group">
                  <label htmlFor="cf-message">Message</label>
                  <textarea
                    id="cf-message"
                    name="message"
                    rows={5}
                    placeholder="Tell me about your project or opportunity..."
                    required
                  />
                  <ValidationError field="message" prefix="Message" errors={state.errors} className="contact-error" />
                </div>
                <button
                  type="submit"
                  className="btn-primary contact-submit"
                  disabled={state.submitting}
                >
                  {state.submitting ? "Sending…" : "Send Message"}
                </button>
              </form>
            )}

            <div className="contact-divider">or reach directly</div>

            <a
              href={`mailto:${personalInfo.email}`}
              className="contact-email-display"
            >
              {personalInfo.email}
            </a>

            <div className="contact-links">
              <a href={`mailto:${personalInfo.email}`} className="contact-link-btn">
                <HiOutlineMail />
                Email
              </a>
              <a href={personalInfo.linkedin} target="_blank" rel="noreferrer" className="contact-link-btn">
                <FaLinkedinIn />
                LinkedIn
              </a>
              <a href={personalInfo.github} target="_blank" rel="noreferrer" className="contact-link-btn">
                <AiFillGithub />
                GitHub
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
